import React from 'react';
import Logo from '../../_assets/images/logo@2x.png';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { authenticationActions } from '../../_actions/authentication.actions';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      practiceId: '',
      username: '',
      password: '',
      submitted: false,
      showAccountDomain: props.showAccountDomain
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showAccountDomain !== this.props.showAccountDomain) {
      this.setState({ showAccountDomain: this.props.showAccountDomain })
    }
  }

  componentDidMount() {
    this.props.dispatch(authenticationActions.clearAll());
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });

    const { practiceId, username, password } = this.state;
    const { dispatch } = this.props;

    if (practiceId && username && password) {
      const path = this.props.location.state ? this.props.location.state.from.pathname : '/';

      dispatch(authenticationActions.login(practiceId, username, password, path));
    }
  }

  render() {
    const { loggingIn, alert } = this.props;

    const { practiceId, username, password, submitted } = this.state;

    return (
      <div className="row h-100">
        <div className="col-lg-10 offset-lg-1 my-auto">
          <div className="card axs-shadow container">
            <div className="row">
              <div className="col-lg-4 d-flex" style={{ backgroundColor: '#1AB2E9' }}>
                <img src={Logo} alt="AxS Logo" className="m-auto" />
              </div>
              <div className="col-12 col-lg-8">
                {this.state.showAccountDomain && <div className='p-4'>
                  <h3 className="mt-3">Great News!</h3>
                  <div className="my-5">
                    <p>You can start using your personalized account domain:</p>
                    <p><a href={`https://${this.state.showAccountDomain.accountData.accountDomain}/login/refresh?auth=${this.state.showAccountDomain.authToken}&clientId=${this.state.showAccountDomain.accountData.id}`} className="btn btn-link">https://{this.state.showAccountDomain.accountData.accountDomain}</a></p>
                    <p>After you click "Continue Login", please bookmark your new page for quick login.</p>
                  </div>
                  <p><a href={`https://${this.state.showAccountDomain.accountData.accountDomain}/login/refresh?auth=${this.state.showAccountDomain.authToken}&clientId=${this.state.showAccountDomain.accountData.id}`} className="btn btn-block btn-success">Continue Login</a></p>
                </div>}

                {!this.state.showAccountDomain && <div className='p-4'>
                  <h3 className="mt-3 text-center">Login</h3>

                  <form name="form" onSubmit={this.handleSubmit}>
                    {alert.message &&
                      <div className={`alert my-4 ${alert.type}`}>{alert.message}</div>
                    }

                    <div className={'form-group' + (submitted && !practiceId ? ' has-error' : '')}>
                      <label htmlFor="practiceId">Practice ID</label>
                      <input type="text" className="form-control" name="practiceId" value={practiceId} onChange={this.handleChange} />
                      {submitted && !practiceId &&
                        <div className="help-block text-danger">Practice ID is required</div>
                      }
                    </div>
                    <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                      <label htmlFor="username">Username</label>
                      <input type="text" className="form-control" name="username" value={username} onChange={this.handleChange} />
                      {submitted && !username &&
                        <div className="help-block text-danger">Username is required</div>
                      }
                    </div>
                    <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                      <label htmlFor="password">Password</label>
                      <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                      {submitted && !password &&
                        <div className="help-block text-danger">Password is required</div>
                      }
                    </div>
                    <div className="form-group mt-4">
                      <button
                        disabled={loggingIn}
                        className="btn btn-primary btn-block ">{loggingIn ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Login'}</button>
                    </div>

                    <Link to="/forgot-password" className="btn btn-link btn-block text-center">Forgot Password</Link>
                  </form>
                </div>}

              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <small>v{process.env.REACT_APP_API_VERSION} (Build {process.env.REACT_APP_BUILD})</small>
          </div>
        </div >
      </div >
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    loggingIn: state.authentication.loggingIn,
    currentUser: state.user.currentUser,
    showAccountDomain: state.authentication.showAccountDomain
  };
}

export default connect(mapStateToProps)(LoginPage);